<template>
  <div>
    <v-card-title>
      <v-row class="py-2">
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select class="px-4" v-model="sector" :items="sectorOpciones" label="Sector"></v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select class="px-4" v-model="bloque" :items="bloqueOpciones" label="Bloque"></v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12" v-if="auxBloqueCampamento">
          <v-select class="px-4" v-model="cultivo" :items="cultivoOpciones" label="Cultivo"></v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12" v-if="auxBloqueCampamento">
          <v-select class="px-4" v-model="etapa" :items="etapaOpciones" label="Etapa"></v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12" v-if="auxBloqueCampamento">
          <v-select class="px-4" v-model="campo" :items="campoOpciones" label="Campo"></v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select class="px-4" v-model="filtro" :items="filtroOpciones" label="Filtro"></v-select>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table
      v-model="seleccionado"
      :headers="headers"
      :items="listadoComedor"
      class="elevation-0 border"
      :single-select="singleSelect"
      :mobile-breakpoint="0"
      item-key="idcomedor"
      show-select
      multi-sort
      no-data-text="No se encontraron datos"
      no-results-text="No se encontraron datos"
      :items-per-page="pagina"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="text-center">
            <v-menu bottom offset-y ref="openMenu">
              <template v-slot:activator="{ on: menu }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn class="mx-2" fab small color="primary" v-on="{ ...tooltip, ...menu }">
                      <v-icon small>fas fa-ellipsis-v</v-icon>
                    </v-btn>
                  </template>
                  <span>Acciones</span>
                </v-tooltip>
              </template>
              <v-list>
                <v-list-item @click.stop="cambiarEstado('H')">
                  <v-list-item-title> Habilitar </v-list-item-title>
                </v-list-item>
                <v-list-item @click.stop="cambiarEstado('D')">
                  <v-list-item-title> Deshabilitar </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-toolbar>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.activo="{ item }">
        <v-icon color="green" small v-if="item.activo == 1">fas fa-square-full</v-icon>
        <v-icon color="red" small v-else-if="item.activo == 0">fas fa-square-full</v-icon>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" :timeout="2000" :color="color">
      {{ text }}
      <v-btn :color="color == 'red' ? 'white' : 'primary'" text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import GestionService from '../services/GestionService';
/* import listTable from '../services/campamento'; */
export default {
  name: 'GestionLista',
  data: () => ({
    snackbar: false,
    text: '',
    color: '',
    dialog: false,
    singleSelect: false,
    seleccionado: [],
    gestionService: null,
    filtro: '',
    filtroOpciones: [
      { text: 'TODOS', value: '' },
      { text: 'HABILITADOS', value: '1' },
      { text: 'DESHABILITADOS', value: '0' }
    ],
    sector: '',
    sectorOpciones: [],
    bloque: '',
    bloqueOpciones: [],
    etapa: '',
    etapaOpciones: [],
    cultivo: '',
    cultivoOpciones: [],
    campo: '',
    campoOpciones: [],
    auxBloqueCampamento: false,
    headers: [
      { text: 'idtipocomedor', value: 'idtipocomedor', width: '150' },
      { text: 'sector', value: 'idsectorpadre', width: '150' },
      { text: 'bloque', value: 'idsector', width: '150' },
      { text: 'cultivo', value: 'cultivo', width: '150' },
      { text: 'etapa', value: 'etapa', width: '150' },
      { text: 'campo', value: 'campo', width: '150' },
      { text: 'numero', value: 'numero', width: '150' },
      { text: 'idunidadcomedor', value: 'idunidadcomedor', width: '150' },
      { text: 'activo', value: 'activo', align: 'center', width: '150' }
    ],
    listadoComedor: []
  }),
  computed: {
    pagina() {
      if (screen.width <= 600) return 5;
      else return 15;
    }
  },
  watch: {
    sector(val) {
      if (val != '') {
        this.open();
        this.iniciaBloque(val);
      }
    },
    bloque(val) {
      if (val != '') {
        this.open();
        this.bloqueOpciones.forEach((element) => {
          if (element.value == val) {
            if (element.escampamento == 0) {
              this.auxBloqueCampamento = true;
              this.iniciaCultivo(val);
            }
            if (element.escampamento == 1) {
              this.campo = '';
              this.etapa = '';
              this.cultivo = '';
              this.auxBloqueCampamento = false;
              this.iniciaListado();
            }
          }
        });
      }
    },
    cultivo(val) {
      if (val != '') {
        this.open();
        this.iniciaEtapa(val);
      }
    },
    etapa(val) {
      if (val != '') {
        this.open();
        this.iniciaCampo(val);
      }
    },
    campo(val) {
      if (val != '') {
        this.open();
        this.iniciaListado();
      }
    },
    filtro() {
      this.open();
      if (this.auxBloqueCampamento) {
        if (this.campo != '') {
          this.iniciaListado();
        }
      } else {
        if (this.bloque != '') {
          this.iniciaListado();
        }
      }
    }
  },
  methods: {
    open() {
      this.$emit('open');
    },
    close() {
      this.$emit('close');
    },
    async iniciaSectorPadre() {
      this.open();
      this.sector = '';
      this.sectorOpciones = [];
      const res = await this.gestionService.get().execResource('sectoresPadres', {
        idempresa: localStorage.getItem('emp')
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.sectorOpciones.push({ text: element.idsectorpadre, value: element.idsectorpadre });
        });
        this.sector = this.sectorOpciones[0].value;
      } else {
        this.close();
      }
    },
    async iniciaBloque(val) {
      this.open();
      this.bloque = '';
      this.bloqueOpciones = [];
      const res = await this.gestionService.get().execResource('bloques', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: val
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.bloqueOpciones.push({
            text: element.idbloque,
            value: element.idbloque,
            escampamento: element.escampamento
          });
        });
        this.bloque = this.bloqueOpciones[0].value;
      } else {
        this.close();
      }
    },
    async iniciaCultivo(val) {
      this.open();
      this.cultivo = '';
      this.cultivoOpciones = [];
      const res = await this.gestionService.get().execResource('cultivos', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: val
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.cultivoOpciones.push({
            text: element.idcultivo,
            value: element.idcultivo
          });
        });
        this.cultivo = this.cultivoOpciones[0].value;
      } else {
        this.close();
      }
    },
    async iniciaEtapa(val) {
      this.open();
      this.etapa = '';
      this.etapaOpciones = [];
      const res = await this.gestionService.get().execResource('etapas', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: this.bloque,
        cultivo: val
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.etapaOpciones.push({
            text: element.idetapa,
            value: element.idetapa
          });
        });
        this.etapa = this.etapaOpciones[0].value;
      } else {
        this.close();
      }
    },
    async iniciaCampo(val) {
      this.open();
      this.campo = '';
      this.campoOpciones = [];
      const res = await this.gestionService.get().execResource('campos', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: this.bloque,
        cultivo: this.cultivo,
        etapa: val
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.campoOpciones.push({
            text: element.idcampo,
            value: element.idcampo
          });
        });
        this.campo = this.campoOpciones[0].value;
      } else {
        this.close();
      }
    },
    async iniciaListado() {
      this.open();
      this.listadoComedor = [];
      const res = await this.gestionService.get().execResource('listar', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: this.bloque,
        cultivo: this.cultivo,
        etapa: this.etapa,
        campo: this.campo,
        activo: this.filtro
      });
      if (res.length > 0) {
        this.listadoComedor = res;
      }
      this.close();
    },
    async consultaApiEstado(data, val) {
      const res = await this.gestionService.put().execResource('estado', {
        data: data,
        value: val
      });
      if (res.status) {
        this.iniciaListado();
      }
      this.seleccionado = [];
    },
    cambiarEstado(val) {
      const aux = [];
      this.seleccionado.forEach((element) => {
        aux.push(element.idunidadcomedor);
      });
      if (aux.length > 0) {
        switch (val) {
          case 'H':
            this.consultaApiEstado(aux, '1');
            break;
          case 'D':
            this.consultaApiEstado(aux, '0');
            break;
        }
      } else {
        this.snackbar = true;
        this.text = 'Seleccione al menos un elemento de la lista.';
        this.color = 'red';
      }
      this.$refs.openMenu.isActive = false;
    }
  },
  async mounted() {
    this.gestionService = this.$httpService(new GestionService(), this);
    this.filtro = this.filtroOpciones[1].value;
    await this.iniciaSectorPadre();
  }
};
</script>
